"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = exports.SpinnerVariant = void 0;
var React = require("react");
var LoadingSpinner_styled_1 = require("./LoadingSpinner.styled");
var SpinnerVariant;
(function (SpinnerVariant) {
    SpinnerVariant[SpinnerVariant["DEFAULT"] = 0] = "DEFAULT";
    SpinnerVariant[SpinnerVariant["RIPPLE"] = 1] = "RIPPLE";
})(SpinnerVariant = exports.SpinnerVariant || (exports.SpinnerVariant = {}));
var getSpinner = function (variant) {
    switch (variant) {
        case SpinnerVariant.RIPPLE:
            return (React.createElement("div", { className: "lds-ripple", "aria-label": "loading" },
                React.createElement("div", null),
                React.createElement("div", null)));
        case SpinnerVariant.DEFAULT:
        default:
            return (React.createElement("div", { className: "lds-ellipsis", "aria-label": "loading" },
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null),
                React.createElement("div", null)));
    }
};
exports.LoadingSpinner = function (props) {
    var spinner = (React.createElement(LoadingSpinner_styled_1.StyledLoadingSpinner, { color: props.color, size: props.size }, getSpinner(props.variant)));
    return props.isModal ? React.createElement(LoadingSpinner_styled_1.StyledModalLoadingSpinner, null, spinner) : spinner;
};
exports.LoadingSpinner.defaultProps = {
    isModal: false,
    size: 80,
    variant: SpinnerVariant.DEFAULT,
};
//# sourceMappingURL=LoadingSpinner.js.map